/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Editor_Heading_3Inputs */

const en_common_editor_heading_3 = /** @type {(inputs: Common_Editor_Heading_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heading 3`)
};

const zh_common_editor_heading_3 = /** @type {(inputs: Common_Editor_Heading_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`三级标题`)
};

/**
* | output |
* | --- |
* | "Heading 3" |
*
* @param {Common_Editor_Heading_3Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_editor_heading_3 = /** @type {((inputs?: Common_Editor_Heading_3Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Editor_Heading_3Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_editor_heading_3(inputs)
	return zh_common_editor_heading_3(inputs)
});
export { common_editor_heading_3 as "common.editor.heading_3" }